import SuperAdminDashboardUser from "./SuperAdminDashboardUser.container";

export default SuperAdminDashboardUser;
